import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { formatDate } from '@/utils/dateHelper';
import { approvalStatus } from '../constants';
import { resolveRequestWorkflow } from '../state/state';

const RequestStatusUpdatedOnListItem = ({
  statusUpdatedOn,
  status,
}) => {
  if (status === approvalStatus.PENDING || !statusUpdatedOn) {
    return null;
  }

  return (
    <List.Item className="aridhia-request-status-updated-on-list-item">
      <List.Header>
        <FormattedMessage id="request.list.actioned.at.title" />
      </List.Header>
      <List.Description
        className="aridhia-form-item-description"
        content={statusUpdatedOn}
      />
    </List.Item>
  );
};

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { status: '' });

  return (
    {
      status: request.status,
      statusUpdatedOn: request.actioned_at ? formatDate(request.actioned_at) : '',
    }
  );
};

export default connect(mapStateToProps)(RequestStatusUpdatedOnListItem);
